// src/tradersData.js

const tradersData = [
  // --- MEN (even indexes), WOMEN (odd indexes) ---
  // Highest profit to lowest, 100 traders total

  { id: 1,  name: "Michael Carter",    profit: 1200000, period: "30d", copies: 40200, winRate: 90, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/men/0.jpg" },
  { id: 2,  name: "Emily Johnson",     profit: 1185000, period: "30d", copies: 39500, winRate: 89, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/women/1.jpg" },
  { id: 3,  name: "Daniel Thompson",   profit: 1170000, period: "30d", copies: 39000, winRate: 89, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/men/2.jpg" },
  { id: 4,  name: "Sarah Campbell",    profit: 1155000, period: "30d", copies: 38500, winRate: 88, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/women/3.jpg" },
  { id: 5,  name: "Jonathan Price",    profit: 1140000, period: "30d", copies: 38000, winRate: 88, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/men/4.jpg" },
  { id: 6,  name: "Hannah Kim",        profit: 1125000, period: "30d", copies: 37200, winRate: 87, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/women/5.jpg" },
  { id: 7,  name: "Christopher Hall",  profit: 1110000, period: "30d", copies: 36500, winRate: 87, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/men/6.jpg" },
  { id: 8,  name: "Michelle Adams",    profit: 1095000, period: "30d", copies: 36000, winRate: 86, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/women/7.jpg" },
  { id: 9,  name: "Andrew Walker",     profit: 1080000, period: "30d", copies: 35800, winRate: 86, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/men/8.jpg" },
  { id:10,  name: "Lauren Carter",     profit: 1065000, period: "30d", copies: 35100, winRate: 85, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/women/9.jpg" },

  { id:11,  name: "Jason Turner",      profit: 1050000, period: "30d", copies: 34500, winRate: 85, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/men/10.jpg" },
  { id:12,  name: "Olivia Harris",     profit: 1035000, period: "30d", copies: 33800, winRate: 84, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/women/11.jpg" },
  { id:13,  name: "Matthew Collins",   profit: 1020000, period: "30d", copies: 33200, winRate: 84, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/men/12.jpg" },
  { id:14,  name: "Ava Mitchell",      profit: 1005000, period: "30d", copies: 32800, winRate: 83, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/women/13.jpg" },
  { id:15,  name: "Brandon Parker",     profit: 995000, period: "30d", copies: 32400, winRate: 83, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/men/14.jpg" },
  { id:16,  name: "Chloe Morgan",       profit: 980000, period: "30d", copies: 31800, winRate: 82, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/women/15.jpg" },
  { id:17,  name: "Aaron Hughes",       profit: 965000, period: "30d", copies: 31400, winRate: 82, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/men/16.jpg" },
  { id:18,  name: "Ella Richardson",    profit: 950000, period: "30d", copies: 30900, winRate: 81, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/women/17.jpg" },
  { id:19,  name: "Kevin Barnes",       profit: 935000, period: "30d", copies: 30500, winRate: 81, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/men/18.jpg" },
  { id:20,  name: "Isabella Stewart",   profit: 920000, period: "30d", copies: 30000, winRate: 80, pnlStatus: "In Profit", image: "https://randomuser.me/api/portraits/women/19.jpg" },

  // --- Continue pattern for remaining 80 traders ---
  // I’ll compress for readability (but still fully valid code)

  ...Array.from({ length: 80 }).map((_, idx) => {
    const id = idx + 21;
    const profit = 915000 - (idx * 7000);   // smooth descending
    const copies = 29800 - (idx * 120);
    const winRate = 60 + ((idx % 31));      // cycles 60–90
    const gender = id % 2 === 0 ? "women" : "men";
    const imageIndex = id % 100;

    const maleNames = [
      "Ryan Brooks","Lucas Evans","Jacob Rogers","Nathan Ward","Ethan Fisher",
      "Logan Howard","Owen Kelly","Noah Rivera","Tyler Brooks","Jack Bennett",
      "Connor Hayes","Gavin Foster","Liam Perez","Eli Henderson","Mason Bryant",
      "Caleb Murphy","Wyatt Simmons","Hunter Phillips","Derek Lane","Jared Coleman",
      "Blake Reid","Shawn Porter","Cody Wheeler","Justin Price","Colin Barnes",
      "Dylan Drake","Aiden Lewis","Spencer Webb","Travis Maxwell","Grant Stevens",
      "Shane Matthews","Colton Pierce","Zachary Holt","Evan Carter","Kyle Ramirez",
      "Shawn Oliver","Marcus Reed","Trevor Dean","Brady Ford"
    ];

    const femaleNames = [
      "Emma Brooks","Sophia Rivera","Ava Coleman","Mia Foster","Charlotte Hayes",
      "Grace Turner","Lily Peterson","Natalie Hughes","Ella Reed","Zoe Henderson",
      "Amelia Morgan","Abigail Taylor","Aria Walker","Nora Bryant","Scarlett Lane",
      "Victoria Collins","Madison Price","Hannah Cooper","Penelope Evans","Layla Stewart",
      "Aubrey Mitchell","Riley Parker","Brooklyn Sanders","Paisley Simmons","Ellie Ward",
      "Savannah Foster","Claire Ross","Lucy Adams","Anna Bennett","Violet Carter",
      "Stella Reed","Naomi Clark","Maya Thompson","Hailey Rogers","Luna Murphy",
      "Eva Howard","Elena Stone","Mariah Jacobs","Summer Hayes"
    ];

    const nameList = gender === "men" ? maleNames : femaleNames;
    const name = nameList[idx % nameList.length];

    return {
      id,
      name,
      profit: Math.max(profit, 320000),
      period: "30d",
      copies: Math.max(copies, 3500),
      winRate: winRate > 90 ? 90 : winRate,
      pnlStatus: "In Profit",
      image: `https://randomuser.me/api/portraits/${gender}/${imageIndex}.jpg`
    };
  })
];

export default tradersData;
